import { render, staticRenderFns } from "./ModalRecipeDescription.vue?vue&type=template&id=236dda28"
import script from "./ModalRecipeDescription.vue?vue&type=script&lang=js"
export * from "./ModalRecipeDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports